import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import styles from './Rating.module.scss';

interface Props {
  revs: number;
  star_rating: number;
}

const Rating: React.FC<Props> = ({ revs, star_rating }) => {
  const starCount = Math.round(Number(star_rating)); // round down to nearest integer
  const orangeStars = new Array(starCount).fill(null);
  const grayStars = new Array(5 - starCount).fill(null);

  return (
    <div className={styles.container}>
      {orangeStars.map((_, i) => (
        <span key={_ || i}>
          <FontAwesomeIcon className={styles.container__icon} icon={faStar} />
        </span>
      ))}
      {grayStars.map((_, i) => (
        <span key={_ || i}>
          <FontAwesomeIcon
            className={`${styles.container__icon} ${styles.container__iconGray}`}
            icon={faStar}
          />
        </span>
      ))}
      <span className={styles.container__reviewCount}>
        (
        {
        revs
        }
        )
      </span>
    </div>
  );
};

export default Rating;
